<template>
  <svg
    width="150"
    height="150"
    viewBox="0 0 150 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="150" height="150" rx="75" fill="var(--card-bg)"/>
    <path
      d="M47.1398 35.3194H85.6096C86.2247 35.3194 86.8147 35.5638 87.2497 35.9988L104.447 53.1956C104.881 53.6306 105.126 54.2206 105.126 54.8357V111.861C105.126 113.142 104.087 114.181 102.806 114.181H47.1398C45.8588 114.181 44.8203 113.142 44.8203 111.861V37.6389C44.8203 36.3579 45.8588 35.3194 47.1398 35.3194Z"
      fill="currentColor"
      fill-opacity="0.1"
      stroke="currentColor"
      stroke-width="3"
    />
    <path d="M86.5703 52.7153V37.6389L103.966 55.0347H88.8898C87.0342 55.0347 86.5703 53.4884 86.5703 52.7153Z" fill="currentColor" stroke="currentColor" stroke-width="2.31944"/>
    <path
      d="M63.8984 72.0618L75.4957 61M75.4957 61L87.0929 72.0618M75.4957 61L75.4957 84.3334"
      stroke="currentColor"
      stroke-width="4.175"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M59.2598 97.9445L59.2598 93.3056C59.2598 92.0246 60.2982 90.9861 61.5792 90.9861L89.4125 90.9861C90.6935 90.9861 91.732 92.0246 91.732 93.3056L91.732 97.9445C91.732 99.2255 90.6935 100.264 89.4125 100.264L61.5792 100.264C60.2982 100.264 59.2598 99.2255 59.2598 97.9445Z" fill="currentColor"/>
    <circle cx="84.2491" cy="95.625" r="2.31944" fill="#ECF5FC"/>
    <g filter="url(#filter0_d_24992_132111)">
      <rect
        x="90"
        y="99"
        width="30"
        height="30"
        rx="15"
        fill="white"
      />
      <path
        d="M110 114H105M105 114H100M105 114V109M105 114V119"
        stroke="#3489FE"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_24992_132111"
        x="74"
        y="83"
        width="62"
        height="62"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="8"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.254902 0 0 0 0 0.631373 0 0 0 0 0.894118 0 0 0 0.24 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_24992_132111"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_24992_132111" result="shape"/>
      </filter>
    </defs>
  </svg>
</template>
<script setup/>
